const MassUploadButton = ({
  children,
  buttonValue = children ? "" : "button",
  type = "submit",
  onClickFunction,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      onClick={onClickFunction}
      disabled={disabled}
      className={
        (disabled
          ? "cursor-not-allowed border text-quaternary opacity-50  border-quaternary "
          : "text-quaternary border-quaternary opacity-100 hover:bg-hquaternary") +
        `hover:scale-90 transition duration-500  shadow-md border-quaternary bg-tranparent  text-quaternary group relative flex justify-center py-1 px-3 border border-transparent text-xs font-medium rounded-full hover:text-white hover:bg-quaternary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70 ${className}`
      }
    >
      {buttonValue}
      {children}
    </button>
  );
};

export default MassUploadButton;
